export default {
  HOME: '/',
  STEP2: '/step-2',
  STEP3: '/step-3',
  STEP4: '/step-4',
  STEP5: '/step-5',
  ORDER: '/order',
}


// WEBPACK FOOTER //
// ./app/javascript/app/constants/routes.js